
    import CardRh from "@/components/cards/ManzaCard.vue";
    import AuditoriaService from "@/service/v1/seguranca/AuditoriaService";
    import { Options, Vue } from "vue-class-component";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import SiteUtils from "@/assets/ts/aplicacao/site";
    import { namespace } from "vuex-class";
    import Multiselect from "@vueform/multiselect";
    import { Prop } from "vue-property-decorator";
    import $ from "jquery";
    import VisualizarSql from "./_VisualizarSql.vue";

    const authStore = namespace("auth");

    @Options({
        name: "LogSql",
        components: { CardRh, KDataTable, Multiselect, VisualizarSql },
    })
    export default class LogSql extends Vue {
        @authStore.Getter
        public perfis!: any;

        @Prop() readonly matricula!: any;

        public tipo_id: any = null;
        public tipos: any = null;
        public data_min: any = null;
        public data_max: any = null;
        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public search = "";
        public descricaoSelecionada = "";
        public modal_visualizar = "kt_visualizar_descricao_log_sql_matricula";

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === "Enter" || e.keyCode === 13) {
                this.refreshTable();
            }
        }

        public limparFiltros() {
            this.search = "";
            this.data_min = null;
            this.data_max = null;
            this.tipo_id = null;
            this.refreshTable();
        }

        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
        }

        get tipos_select() {
            if (this.tipos) {
                return this.tipos.map((item) => {
                    return { value: item.id, label: item.nome };
                });
            }
            return [];
        }

        public getTipo() {
            this.processando = true;
            this.service.getTipo()
                .then(response => {
                    this.tipos = JSON.parse(JSON.stringify(response));
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }

        created() {
            this.config = { order: [[0, "desc"]], ajax: {}, columns: {}, columnDefs: {} };
            this.service = new AuditoriaService();
            this.getTipo();
            this.config.ajax = {
                url: this.service.getApiUrl(),
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        DataMin: this.data_min,
                        DataMax: this.data_max,
                        modelId: this.matricula.id,
                        model: "Matricula",
                        tipoId: this.tipo_id,
                        search: this.search || d.search.value,
                    };
                    return dados;
                }
            };

            this.config.columns = [
                { data: "createdAt", name: "createdat", searchable: false, class: "text-center" },
                { data: "tipo", name: "tipo", searchable: false, class: "text-center" },
                { data: "descricao", name: "descricao", searchable: false, class: "text-center" },
                { data: "enderecoIP", name: "enderecoip", searchable: false, class: "text-center" },
                { data: "usuarioId", name: "usuarioid", searchable: false, class: "text-center" },
                { data: "host", name: "host", searchable: false, class: "text-center" },
            ];

            this.config.columnDefs = [
                {
                    targets: 0,
                    render: (row) => {
                        return SiteUtils.formatDataHora(row);
                    }
                },
                {
                    targets: 1,
                    render: (row) => {
                        return row != null ? row.nome : "";
                    }
                },
                {
                    targets: 2,
                    render: (row) => {
                        const descricaoCodificada = encodeURIComponent(row ?? "");
                        return '<button class="btn btn-light-pmes-primary btn-sm" btn-visualizar-descricao-sql data-descricao="' + descricaoCodificada + '" data-bs-toggle="modal" data-bs-target="#' + this.modal_visualizar + '">Visualizar</button>';
                    }
                },
            ];
        }

        public tableatualizada() {
            $("[btn-visualizar-descricao-sql]").off("click").on("click", (btn) => {
                const descricaoCodificada = $(btn.currentTarget).attr("data-descricao") || "";
                this.descricaoSelecionada = descricaoCodificada ? decodeURIComponent(descricaoCodificada) : "";
            });
        }
    }
